import { render } from "./reportealertasenviado.vue?vue&type=template&id=553b8e40"
import script from "./reportealertasenviado.vue?vue&type=script&lang=js"
export * from "./reportealertasenviado.vue?vue&type=script&lang=js"

import "./reportealertasenviado.vue?vue&type=style&index=0&id=553b8e40&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__